import { UitkPill } from "@egds/react-core/pill";
import * as React from "react";
import { FilterPillProps, FilterPillStates } from "components/flexComponents/Flights/typings";
import { locKeys } from "./l10";

class FilterPill extends React.Component<FilterPillProps, FilterPillStates> {
  constructor(props: FilterPillProps) {
    super(props);
    this.state = {
      filterPillStatus: [],
    };
  }

  public componentDidMount(): void {
    this.setActiveState(0);
  }

  setActiveState = (index: number) => {
    const numOfMonths = this.props.availableMonths.length;
    const activeStatus = [];
    for (let i = 0; i < numOfMonths + 1; i++) {
      activeStatus.push(false);
    }
    activeStatus[index] = true;
    this.setState({
      filterPillStatus: activeStatus,
    });
  };

  filterAllDeals = () => {
    this.setActiveState(0);
    this.props.filterAllDeals();
  };

  filterByMonth = (month: number, index: number) => {
    return () => {
      this.setActiveState(index);
      this.props.filterByMonth(month);
    };
  };

  render() {
    const { formatText, moduleId, showMonthFilter, availableMonths } = this.props;
    const { filterPillStatus } = this.state;
    if (!showMonthFilter) {
      return null;
    }
    return (
      <div>
        <UitkPill
          onChange={this.filterAllDeals}
          checked={filterPillStatus[0]}
          active={filterPillStatus[0]}
          id={`${moduleId}-FilterPill0`}
        >
          {formatText(locKeys.flightAllDealsText)}
        </UitkPill>
        {availableMonths.map((month, monthIndex) => (
          <UitkPill
            key={monthIndex}
            onChange={this.filterByMonth(month, monthIndex + 1)}
            checked={filterPillStatus[monthIndex + 1]}
            active={filterPillStatus[monthIndex + 1]}
            id={`${moduleId}-FilterPill${monthIndex + 1}`}
          >
            {formatText(`${locKeys.flightFilteredMonth}${month}`)}
          </UitkPill>
        ))}
      </div>
    );
  }
}

export default FilterPill;
